import { useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import API from "@/lib/api";
import { ENTITY_CONFIG } from "@/lib/entityConfig";

export default function DeleteConfirmDialog({ open, item, entityType, onClose, onDelete }) {
  const config = ENTITY_CONFIG[entityType];
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!item?.id) return;
    setDeleting(true);
    try {
      await API.delete(`/${config.apiPath}/${item.id}`);
      onDelete?.();
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
    }
  };

  if (!config) return null;

  const displayName = item?.[config.nameField] || item?.name || item?.id || "";

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent className="bg-card border-border" data-testid="delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {config.label.replace(/s$/, "")}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete <span className="font-semibold text-foreground">"{displayName}"</span>?
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="secondary" onClick={onClose} data-testid="delete-cancel">Cancel</Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleting}
            data-testid="delete-confirm"
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
